import gql from "graphql-tag";

export default gql`
  query RoomTemplates($offset: Int, $limit: Int, $contractId: ID, $customerId: ID) {
    roomTemplates(offset: $offset, limit: $limit, contractId: $contractId, customerId: $customerId) {
      items {
        id
        codename
        description
        contractId
      }
      total
    }
  }
`;
